document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {

        var productPage = document.querySelector('.single-product');
         if (!productPage) return;

        var input = document.querySelector('.product__quantity-input');
        var addToCart = document.querySelector('.product-cart__single-button');
        // Handle clicking plus/minus buttons
        var plusBtn = document.querySelector('.product__plus');
        var minusBtn = document.querySelector('.product__minus');

        if (!input) return;

        // Create or get the error message element
        var errorMessage = input.nextElementSibling;
        if (!errorMessage || !errorMessage.classList.contains('product__quantity-error-message')) {
            errorMessage = document.createElement('span');
            errorMessage.classList.add('product__quantity-error-message');
            input.insertAdjacentElement('afterend', errorMessage);
        }

        // Shared validation function
        function validateQuantity() {
            var inputValue = parseFloat(input.value);
            var maxValue = parseFloat(input.max);

            if (inputValue > maxValue) {
                errorMessage.classList.add('product__quantity-error-message--active');
                // errorMessage.textContent = 'Only ' + maxValue + ' available. Need more? <a href="/contact-us/">Contact us</a>';
                errorMessage.innerHTML = 'Only ' + maxValue + ' available. Need more? <a href="/contact/">Contact us</a>';

                
                if (addToCart) { 
                    addToCart.disabled = true; 
                }
            } else {
                errorMessage.classList.remove('product__quantity-error-message--active');
                errorMessage.textContent = '';
                if (addToCart) { 
                    addToCart.disabled = false;
                }
            }

            if (inputValue >= maxValue) {
                plusBtn.disabled = true;
            } else {
                plusBtn.disabled = false;
            }
        }

        // Handle typing directly in the input
        input.addEventListener('input', function() {
            this.setCustomValidity('');
            validateQuantity();
        });

        // Handle invalid HTML5 validation on submit
        input.addEventListener('invalid', function() {
            var maxValue = parseFloat(this.max);
            this.setCustomValidity('Only ' + maxValue + ' available. Need more? Contact us');
        });

        if (plusBtn) {
            plusBtn.addEventListener('click', function() {
                setTimeout(validateQuantity, 0);
            });
        }

        if (minusBtn) {
            minusBtn.addEventListener('click', function() {
                setTimeout(validateQuantity, 0);
            });
        }
    }, 1); // Delay DOM logic
});